// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getBeginWeeks, getEndWeeks
} from '../../common/repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import CheckAttachmentOrdersByBuildWeekTable from './components/check-attachment-orders-by-build-week-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatGivenDate } from '../../shared/services/common-functions';
import getAttachmentOrderByBuildWeek from './repositories';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class CheckAttachmentOrdersByBuildWeek extends Component {

    state = {
        results: null,
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: ''
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryBeginWeek = query.get( 'beginweek' );
        const queryEndWeek = query.get( 'endweek' );
        this.handleQueryParams( queryBeginWeek, queryEndWeek );

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryBeginWeek = query.get( 'beginweek' );
            const queryEndWeek = query.get( 'endweek' );
            this.handleQueryParams( queryBeginWeek, queryEndWeek );
            window.scrollTo( 0, 0 );

        }

    }

    handleQueryParams ( queryBeginWeek, queryEndWeek ) {

        this.props.increaseCounter();

        if ( ( this.state.selectedBeginWeek !== '-1' && this.state.selectedEndWeek !== '-1' ) || ( queryBeginWeek && queryEndWeek ) ) {

            this.props.increaseCounter();
            getBeginWeeks( ).then( response => {

                const bWeeks = response.map( i => {

                    const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                    let wkn = wk;
                    if ( wk === '2000-01-01' ) wkn = 'Inventory';
                    if ( wk === '2000-02-01' ) wkn = 'Rework';
                    return { id: wk, value: wkn };

                } );
                this.setState( {
                    beginWeeks: bWeeks
                } );
                if ( queryBeginWeek ) {

                    this.setState( {
                        selectedBeginWeek: queryBeginWeek
                    } );
                    getEndWeeks( queryBeginWeek ).then( endWeekResponse => {

                        const eWeeks = endWeekResponse.map( i => {

                            const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                            let wkn = wk;
                            if ( wk === '2000-01-01' ) wkn = 'Inventory';
                            if ( wk === '2000-02-01' ) wkn = 'Rework';
                            return { id: wk, value: wkn };

                        } );
                        this.setState( {
                            endWeeks: eWeeks,
                            selectedEndWeek: queryEndWeek,
                            results: null
                        }, () => {

                            this.refresh();

                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }
        this.props.decreaseCounter();

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: '',
            results: null
        }, () => {

            if ( this.state.selectedBeginWeek !== '-1' ) {

                this.props.increaseCounter();
                getEndWeeks( val ).then( response => {

                    const eWeeks = response.map( i => {

                        const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        endWeeks: eWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            this.refresh();

        } );

    }

    handleCheckAttachmentOrderBuildWeek ( beginWeek, endWeek ) {

        this.props.increaseCounter();
        getAttachmentOrderByBuildWeek( beginWeek, endWeek )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    refresh () {

        const { selectedBeginWeek } = this.state;
        const { selectedEndWeek } = this.state;
        this.handleCheckAttachmentOrderBuildWeek( selectedBeginWeek, selectedEndWeek );

    }

    render () {

        const {
            selectedBeginWeek, selectedEndWeek, beginWeeks, endWeeks, results
        } = this.state;

        const mapResults = [];
        let k = 1;
        let orders = 0;
        if ( results !== null && results !== undefined ) {

            for ( let i = 0; i < results.length; i += 1 ) {

                const resultWithUnitName = results[i].ordAttachmentDetails.map( order => (
                    { ...order, ...{ unitName: this.props.unit.name } } ) );
                orders += resultWithUnitName.length;
                const totalOrderForGrid = resultWithUnitName.length;
                resultWithUnitName[totalOrderForGrid] = { model: '0', message: `Total Orders: ${totalOrderForGrid}` };
                mapResults[k] = resultWithUnitName;
                mapResults[k].buildWeek = results[i].buildWeek;
                k += 1;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Check Attachment Orders By Order Build Week</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-check-attachment-order-by-build-week-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-attachment-build-week-select"
                                    label="Begin Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleBeginWeekChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={beginWeeks}
                                    placeholder="Select Begin Week"
                                    selectedValue={selectedBeginWeek}
                                />
                                {selectedBeginWeek && selectedBeginWeek !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-attachment-build-week-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}

                                {selectedBeginWeek && selectedEndWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>
                        </div>
                        <section className="messagecontainer">
                            { results !== null && (
                                <div className="displayBuildWkMessage">
                                    <span className="buildWkMsg">Build week is the build week of the order.</span>
                                </div>
                            ) }
                            {results !== null && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && (
                                <div className="displayErrorMessage">Total Orders for Time Period: {orders}</div>
                            ) }
                        </section>
                        {results !== null && mapResults !== undefined && mapResults.map( ( item, index ) => (
                            <CheckAttachmentOrdersByBuildWeekTable
                                key={`attachment-week-${item.buildWeek}-${index}`}
                                results={item}
                                buildWeek={item.buildWeek}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

CheckAttachmentOrdersByBuildWeek.displayName = 'CheckAttachmentOrdersByBuildWeek';
CheckAttachmentOrdersByBuildWeek.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( CheckAttachmentOrdersByBuildWeek ) );
